import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-mediascrollablecontent.as-media-left").forEach((el) => {
  const sectionsPlaceholder = el.querySelector(".scroll-sections-placeholder");
  const sectionPlaceholders = el.querySelectorAll(".scroll-section-placeholder");
  const sections = el.querySelectorAll(".scroll-section");
  const contents = el.querySelectorAll(".scroll-content");

  contents.forEach((content) => {
    const height = content.offsetHeight;
    const styles = window.getComputedStyle(content);
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

    content.setAttribute("data-height", height + margin);
  });

  gsap.set(sections, { opacity: 0.4 });
  gsap.set(contents, { height: 0 });

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el.querySelector(".scroll-sections"),
      start: "top center",
      end: () => {
        return `${sectionsPlaceholder.offsetHeight}px center`;
      },
      scrub: true,
      markers: false,
    },
  });

  contents.forEach((content) => {
    timeline.to(content, { height: content.dataset.height });
  });

  sectionPlaceholders.forEach((section) => {
    const target = Array.from(sections).filter((el) => el.dataset.index === section.dataset.index);

    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "top center",
      scrub: true,
      markers: false,
      onEnter: () => {
        gsap.to(target, { opacity: 1 });
      },
      onEnterBack: () => {
        gsap.to(target, { opacity: 0.4 });
      },
    });
  });

  ScrollTrigger.refresh();
});

document.querySelectorAll(".element-mediascrollablecontent.as-media-right").forEach((el) => {
  const sectionsPlaceholder = el.querySelector(".scroll-sections-placeholder");
  const sectionPlaceholders = el.querySelectorAll(".scroll-section-placeholder");
  const sections = el.querySelectorAll(".scroll-section");
  const contents = el.querySelectorAll(".scroll-content");

  contents.forEach((content) => {
    const height = content.offsetHeight;
    const styles = window.getComputedStyle(content);
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

    content.setAttribute("data-height", height + margin);
  });

  gsap.set(sections, { opacity: 0.4 });
  gsap.set(contents, { height: 0 });

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el.querySelector(".scroll-sections"),
      start: "top center",
      end: () => {
        return `${sectionsPlaceholder.offsetHeight}px center`;
      },
      scrub: true,
      markers: false,
    },
  });

  contents.forEach((content) => {
    timeline.to(content, { height: content.dataset.height });
  });

  sectionPlaceholders.forEach((section) => {
    const target = Array.from(sections).filter((el) => el.dataset.index === section.dataset.index);

    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "top center",
      scrub: true,
      markers: false,
      onEnter: () => {
        gsap.to(target, { opacity: 1 });
      },
      onEnterBack: () => {
        gsap.to(target, { opacity: 0.4 });
      },
    });
  });

  ScrollTrigger.refresh();
});
